import React from 'react';
import * as PropTypes from 'prop-types';
import { ButtonGroup, Button } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatureFlippingComponent from 'components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER } from 'components/FeatureFlipping/featureFlipping.func';
import RoutesEspaceDetenteurs from '../../../../armes/signaler-erreur/routes';
import RoutesTransfertPourPret from '../../../../armes/transfert-pret/routes';
import BoutonArmePerdueVolee from '../PerdueVolee/BoutonArmePerdueVolee';
import BoutonValiderAcquisition from '../ValiderAcquisition/BoutonValiderAcquisition';
import verifierDroits from '../../../../../../components/VerifierDroits/verifierDroits.func';
import { STATUTS_METIER_ASSO } from '../../../../../../utils/Statuts.MetierAsso.constant';

import {
    ROLE_HERITIER,
    ROLE_COLLECTIONNEUR,
    ROLE_CORRECTION_RATELIER_ARMES,
    DROITS_RATELIER_SIGNALER_UNE_ERREUR,
    ROLE_METIER_ASSOCIATION,
} from '../../../../../../utils/droitsEtRoles.constant';
import BoutonSupprimerArme from '../SupprimerArme/BoutonSupprimerArme';
import BoutonRestituerPret from '../RestituerPret/BoutonRestituerPret';
import {
    isFeatureActive,
    FEATURE_DEMANDER_SUPPRESSION_ARME,
} from '../../../../../../components/FeatureFlipping/featureFlipping.func';
import VerifierDroitsComponent from '../../../../../../components/VerifierDroits/VerifierDroitsComponent';
import {
    BOUTON_PERDUE_VOLEE,
    BOUTON_SIGNALER_ERREUR,
    BOUTON_SUPPRIMER,
    BOUTON_TRANSFERT_POUR_PRET,
    BOUTON_RESTITUTION_PRET,
    BOUTON_VALIDER_ACQUISITION,
    listeBoutonsPossibles,
} from './BoutonActionsFunctions';
import { getPath } from '../../../../../../utils/router';
import { LIBELLE_PRET } from '../../../../../../components/arme/statuts/StatutsArmes';

const TemplateBoutonsActions = ({
    armesSelectionnees,
    rechargerTableau,
    rolesProfil,
    ouvrirModalePerteVol,
    fermerModale,
    featureFlipping,
    ouvrirModaleValiderAcquisition,
    dataProfil,
}) => {
    const isMineurNonEmancipe = dataProfil?.mineurEmancipe === false;
    const ajouterBoutonSignalerErreur = (droits) => {
        return (
            <VerifierDroitsComponent droits={droits}>
                <Link
                    to={getPath(RoutesEspaceDetenteurs, {
                        uuidArme: armesSelectionnees[0].uniquid,
                    })}
                    style={{ backgroundImage: 'none' }}
                >
                    <Button
                        variant="primary"
                        disabled={
                            verifierDroits(dataProfil, [ROLE_METIER_ASSOCIATION]) ||
                            isMineurNonEmancipe
                        }
                    >
                        Signaler une erreur
                    </Button>
                </Link>
            </VerifierDroitsComponent>
        );
    };
    const getBouton = (bouton) => {
        switch (bouton) {
            case BOUTON_SUPPRIMER:
                if (!isFeatureActive(featureFlipping, FEATURE_DEMANDER_SUPPRESSION_ARME)) {
                    return null;
                }
                return <BoutonSupprimerArme armesSelectionnees={armesSelectionnees} />;
            case BOUTON_VALIDER_ACQUISITION:
                return (
                    <BoutonValiderAcquisition
                        ouvrirModaleValiderAcquisition={ouvrirModaleValiderAcquisition}
                        armesSelectionnees={armesSelectionnees}
                        rechargerTableau={rechargerTableau}
                        fermerModaleInfo={fermerModale}
                    />
                );
            case BOUTON_TRANSFERT_POUR_PRET:
                if (
                    !dataProfil?.roles.includes(ROLE_METIER_ASSOCIATION) ||
                    (dataProfil?.sousStatut !== STATUTS_METIER_ASSO.METIER_MORALE_MUSEES &&
                        dataProfil?.sousStatut !==
                            STATUTS_METIER_ASSO.METIER_MORALE_FORMATION_ARMURERIE)
                ) {
                    return null;
                }

                return (
                    <Link
                        to={getPath(RoutesTransfertPourPret, {
                            uuidArme: armesSelectionnees[0].uniquid,
                        })}
                        style={{ backgroundImage: 'none' }}
                    >
                        <Button variant="primary">Transférer pour prêt</Button>
                    </Link>
                );
            case BOUTON_RESTITUTION_PRET:
                // Pas de restitution pour les prêts professionnels (via LPN)
                if (armesSelectionnees[0].statut !== LIBELLE_PRET) {
                    return null;
                }

                return (
                    <BoutonRestituerPret
                        armesSelectionnees={armesSelectionnees}
                        rechargerTableau={rechargerTableau}
                        fermerModale={fermerModale}
                    />
                );
            case BOUTON_PERDUE_VOLEE:
                return (
                    <BoutonArmePerdueVolee
                        ouvrirModalePerteVol={ouvrirModalePerteVol}
                        fermerModaleInfo={fermerModale}
                        armesSelectionnees={armesSelectionnees}
                    />
                );
            case BOUTON_SIGNALER_ERREUR:
                // RG 6 : pour les collectionneurs, le bouton est toujours présent mais désactivé
                if (dataProfil?.roles?.includes(ROLE_COLLECTIONNEUR)) {
                    return (
                        <Button variant="primary" disabled>
                            Signaler une erreur
                        </Button>
                    );
                }

                if (!rolesProfil || !rolesProfil.includes(ROLE_CORRECTION_RATELIER_ARMES)) {
                    return null;
                }

                return (
                    <>
                        <VerifierDroitsComponent droits={DROITS_RATELIER_SIGNALER_UNE_ERREUR}>
                            <Link
                                to={getPath(RoutesEspaceDetenteurs, {
                                    uuidArme: armesSelectionnees[0].uniquid,
                                })}
                                style={{ backgroundImage: 'none' }}
                            >
                                <Button
                                    variant="primary"
                                    disabled={
                                        verifierDroits(dataProfil, [ROLE_METIER_ASSOCIATION]) ||
                                        isMineurNonEmancipe
                                    }
                                >
                                    Signaler une erreur
                                </Button>
                            </Link>
                        </VerifierDroitsComponent>

                        {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
                        <FeatureFlippingComponent
                            featureName={
                                FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER
                            }
                        >
                            {ajouterBoutonSignalerErreur([ROLE_HERITIER])}
                        </FeatureFlippingComponent>
                    </>
                );
            default:
                return null;
        }
    };

    const listeBoutons = listeBoutonsPossibles(armesSelectionnees);

    if (armesSelectionnees && armesSelectionnees.length > 0 && listeBoutons.length === 0) {
        return <>Aucune action possible sur la sélection.</>;
    }

    return (
        <ButtonGroup align="left" inline>
            <Button variant="secondary" name="fermer" onClick={fermerModale}>
                Fermer
            </Button>
            {listeBoutons.map((bouton) => {
                return <React.Fragment key={bouton}> {getBouton(bouton)} </React.Fragment>;
            })}
        </ButtonGroup>
    );
};

TemplateBoutonsActions.propTypes = {
    armesSelectionnees: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string.isRequired,
            statut: PropTypes.string.isRequired,
            statutId: PropTypes.number.isRequired,
            lettreEncodage: PropTypes.string.isRequired,
        }).isRequired,
    ),
    rechargerTableau: PropTypes.func.isRequired,
    rolesProfil: PropTypes.array,
    featureFlipping: PropTypes.object.isRequired,
    fermerModale: PropTypes.func.isRequired,
    ouvrirModalePerteVol: PropTypes.func.isRequired,
    ouvrirModaleValiderAcquisition: PropTypes.func.isRequired,
    dataProfil: PropTypes.shape({
        roles: PropTypes.array.isRequired,
        mineurEmancipe: PropTypes.bool,
        sousStatut: PropTypes.string,
    }),
};

TemplateBoutonsActions.defaultProps = {
    rolesProfil: [],
};

export default connect((state) => {
    const { data: featureFlipping } = state.featureFlipping;

    const { data: dataProfil } = state.profil.usager;

    return { featureFlipping, dataProfil };
}, {})(TemplateBoutonsActions);
